/* eslint-disable no-unused-vars */
/* eslint-disable  array-callback-return */
import React, { useRef, useState } from "react";
import "./LoginScreen.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import {
  GetApiWithoutToken,
  PostApiWithoutToken,
} from "../../services/ApiService";
import ShowLoader from "../../commonComponents/ShowLoader";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import {
  ErrorNotify,
  SuccessNotify,
} from "../../commonComponents/ToastMessage";
import { ToastContainer } from "react-toastify";
import { FiLock } from "react-icons/fi";

const LoginScreen = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [passwordHide, setPasswordHide] = useState(true);
  const [activeTab, setActiveTab] = useState("login");
  const [forgotUser, setForgotUser] = useState("");

  const [otp, setOtp] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const otp1 = useRef();
  const otp2 = useRef();
  const otp3 = useRef();
  const otp4 = useRef();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [changePasswordHide, setChangePasswordHide] = useState(true);
  const [confirmchangePasswordHide, setConfirmchangePasswordHide] =
    useState(true);
  const [error, setError] = useState("");

  const SendOtp = () => {
    setShowLoader(true);
    GetApiWithoutToken(`users/get-otp/forgot_password/${forgotUser}`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setShowLoader(false);
          SuccessNotify(res.message);
          setActiveTab("verifyOTP");
        } else {
          setShowLoader(false);
          ErrorNotify(res.message);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        ErrorNotify(error);
        console.log(error);
      });
  };

  const VerifyOtp = () => {
    setShowLoader(true);
    GetApiWithoutToken(
      `users/verify-otp/forgot_password/${forgotUser}/${
        otp.otp1 + otp.otp2 + otp.otp3 + otp.otp4
      }`,
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setOtp({
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
          });
          setShowLoader(false);
          SuccessNotify(res.message);
          setActiveTab("updatepw");
        } else {
          setShowLoader(false);
          ErrorNotify(res.message);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        ErrorNotify(error);
        console.log(error);
      });
  };

  const UpdatePassword = () => {
    setShowLoader(true);
    let body = {
      email: forgotUser,
      new_password: password,
    };
    PostApiWithoutToken(`users/reset-password`, JSON.stringify(body))
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setForgotUser("");
          setShowLoader(false);
          SuccessNotify(res.message);
          setActiveTab("login");
        } else {
          setShowLoader(false);
          ErrorNotify(res.message);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        ErrorNotify(error);
        console.log(error);
      });
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    if (password && value !== password) {
      setError("Password and Confirm Password must be same");
    } else {
      setError("valid");
    }
  };

  const LoginFunction = () => {
    if (user === "" && pwd === "") {
      ErrorNotify("Email and Password are empty");
      return;
    } else if (pwd === "") {
      ErrorNotify("Password is empty");
      return;
    } else if (user === "") {
      ErrorNotify("Email is empty");
      return;
    }

    let loginBody = {
      email: user,
      password: pwd,
    };
    setShowLoader(true);
    PostApiWithoutToken("login", JSON.stringify(loginBody))
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setShowLoader(false);
          SuccessNotify(res.message);
          const accessToken = res.data.access_token;
          const role = res.data.user?.role;
          const clientId = res.data.user?.clientId;
          const pages = res?.data?.user?.pages;
          const pageAccess = pages
            .filter((item) => item.isSelected)
            .map((item) => item.name)
            .concat("Settings");

          sessionStorage.setItem(
            "loginUser",
            JSON.stringify({
              role,
              accessToken,
              clientId,
              user: res?.data?.user,
              pages: pageAccess,
            }),
          );
          setAuth({
            role,
            accessToken,
            clientId,
            user: res?.data?.user,
            pages: pageAccess,
          });

          const routes = {
            "HO Dashboard": "/",
            "Operational Dashboard": "/operational-dashboard",
            "User Master": "/administrator",
            "Equipment Master": "/administrator",
            "Iot Devices Master": "/administrator",
            "Machine Breakdown hrs": "/administrator",
            "Override Approval": "/administrator",
            Alerts: "/alerts",
          };

          const found = Object.keys(routes).find((key) =>
            pageAccess.includes(key),
          );
          navigate(found ? routes[found] : "/settings", { replace: true });
        } else {
          setShowLoader(false);
          ErrorNotify(res.message);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        ErrorNotify(error);
        console.log(error);
      });
  };

  return (
    <div className="h-100vh">
      {showLoader ? <ShowLoader></ShowLoader> : null}
      <ToastContainer />
      <div
        className="h-100 d-flex w-100"
        style={{ backgroundColor: "var(--bgColor)" }}
      >
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center h-100">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img
              src={require("../../assets/logo.jpg")}
              alt="logo"
              className=""
              style={{ height: 100 }}
            />
            <div className="py-3 fs-30">
              {activeTab === "login" ? "LOGIN" : ""}
            </div>
          </div>
          {activeTab === "login" ? (
            <div className="col-12 col-sm-6 p572 ">
              <label>Email</label>
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control inputField outlineInput pl-30"
                  id="name"
                  onChange={(e) => {
                    setUser(e.target.value);
                  }}
                />
                <div className="position-absolute inputicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person text-black"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                  </svg>
                </div>
              </div>
              <div className="pt-20">
                <label>Password</label>
                <div className="input-group position-relative">
                  <input
                    type={passwordHide ? "password" : "text"}
                    className="form-control outlineInput inputField pl-30"
                    id="password"
                    onChange={(e) => {
                      setPwd(e.target.value);
                    }}
                  />
                  <div className="position-absolute inputicon">
                    <FiLock color="#000" />
                  </div>
                  <span className="input-group-text">
                    {passwordHide ? (
                      <BsEyeSlashFill
                        onClick={() => {
                          setPasswordHide(false);
                        }}
                      />
                    ) : (
                      <BsEyeFill
                        onClick={() => {
                          setPasswordHide(true);
                        }}
                      />
                    )}
                  </span>
                </div>
              </div>
              <div className="text-end py-4">
                <span
                  className="fs-14 cursor"
                  onClick={() => {
                    setActiveTab("forgotpw");
                  }}
                >
                  Forgot password?
                </span>
              </div>
              <button
                className="btn btn-primary w-100 btnbg"
                onClick={() => {
                  LoginFunction();
                }}
              >
                Login
              </button>
            </div>
          ) : activeTab === "forgotpw" ? (
            <div className="col-12 col-sm-6  p572 text-center">
              <h3>Forgot your password?</h3>
              <p>Enter Your Email</p>
              <div className="position-relative mt-50">
                <input
                  type="text"
                  className="form-control inputField outlineInput"
                  id="forgot"
                  value={forgotUser}
                  placeholder="Email"
                  onChange={(e) => {
                    setForgotUser(e.target.value);
                  }}
                />
                {/* <div className="position-absolute inputicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-telephone"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                  </svg>
                </div> */}
              </div>
              <div className="text-end py-4">
                <span
                  className="fs-14 cursor"
                  onClick={() => {
                    setActiveTab("login");
                  }}
                >
                  Cancel
                </span>
              </div>
              <button
                className="btn btn-primary w-100 btnbg"
                onClick={() => {
                  if (forgotUser) {
                    SendOtp();
                  } else {
                    ErrorNotify("Please Provide Email or Phone Nunmber");
                  }
                }}
              >
                Get OTP
              </button>
            </div>
          ) : activeTab === "verifyOTP" ? (
            <div className="col-12 col-sm-6 p572 text-center">
              <h3>Verify OTP</h3>
              <div className="mt-50 d-flex justify-content-center">
                <input
                  ref={otp1}
                  type="email"
                  className="form-control loginOtpInput"
                  value={otp.otp1}
                  onChange={(e) => {
                    setOtp({ ...otp, otp1: e.target.value });
                    if (e.target.value.length >= 1) {
                      otp2.current.focus();
                    }
                  }}
                  maxLength={1}
                />
                <input
                  ref={otp2}
                  type="email"
                  className="form-control loginOtpInput"
                  value={otp.otp2}
                  onChange={(e) => {
                    setOtp({ ...otp, otp2: e.target.value });
                    if (e.target.value.length >= 1) {
                      otp3.current.focus();
                    } else {
                      otp1.current.focus();
                    }
                  }}
                  maxLength={1}
                />
                <input
                  ref={otp3}
                  type="email"
                  className="form-control loginOtpInput"
                  value={otp.otp3}
                  onChange={(e) => {
                    setOtp({ ...otp, otp3: e.target.value });
                    if (e.target.value.length >= 1) {
                      otp4.current.focus();
                    } else {
                      otp2.current.focus();
                    }
                  }}
                  maxLength={1}
                />
                <input
                  ref={otp4}
                  type="email"
                  className="form-control loginOtpInput"
                  value={otp.otp4}
                  onChange={(e) => {
                    setOtp({ ...otp, otp4: e.target.value });
                    if (e.target.value.length >= 1) {
                    } else {
                      otp3.current.focus();
                    }
                  }}
                  maxLength={1}
                />
              </div>
              <div className="d-flex justify-content-between py-4">
                <span
                  className="resendText"
                  onClick={() => {
                    if (forgotUser) {
                      SendOtp();
                    }
                  }}
                >
                  Re-send OTP
                </span>
                <div>
                  <span
                    className="fs-14 cursor"
                    onClick={() => {
                      setActiveTab("login");
                    }}
                  >
                    Cancel
                  </span>
                </div>
              </div>
              <button
                className="btn btn-primary w-100 btnbg mt-3"
                onClick={() => {
                  VerifyOtp();
                }}
              >
                Verify
              </button>
            </div>
          ) : activeTab === "updatepw" ? (
            <div className="col-12 col-sm-6 p572 ">
              <div className="text-center">
                <h3>New Password</h3>
              </div>
              <label className="pt-20">Password</label>
              <div className="input-group position-relative">
                <input
                  type={changePasswordHide ? "password" : "text"}
                  className="form-control outlineInput inputField pl-30"
                  id="confirmpassword"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (confirmPassword && e.target.value !== confirmPassword) {
                      setError("Password and Confirm Password must be same.");
                    } else {
                      setError("valid");
                    }
                  }}
                  value={password}
                />
                <div className="position-absolute inputicon">
                  <FiLock />
                </div>
                <span className="input-group-text">
                  {changePasswordHide ? (
                    <BsEyeSlashFill
                      onClick={() => {
                        setChangePasswordHide(false);
                      }}
                    />
                  ) : (
                    <BsEyeFill
                      onClick={() => {
                        setChangePasswordHide(true);
                      }}
                    />
                  )}
                </span>
              </div>
              <div className="pt-20">
                <label>Confirm Password</label>
                <div className="input-group position-relative">
                  <input
                    type={confirmchangePasswordHide ? "password" : "text"}
                    className="form-control outlineInput inputField pl-30"
                    id="psd"
                    onChange={handleConfirmPasswordChange}
                    value={confirmPassword}
                  />
                  <div className="position-absolute inputicon">
                    <FiLock />
                  </div>
                  <span className="input-group-text">
                    {confirmchangePasswordHide ? (
                      <BsEyeSlashFill
                        onClick={() => {
                          setConfirmchangePasswordHide(false);
                        }}
                      />
                    ) : (
                      <BsEyeFill
                        onClick={() => {
                          setConfirmchangePasswordHide(true);
                        }}
                      />
                    )}
                  </span>
                </div>
                {error !== "valid" && (
                  <div
                    style={{ color: "red", marginTop: "4px" }}
                    className="fs-14"
                  >
                    {error}
                  </div>
                )}
              </div>
              <div className="text-end py-4">
                <span
                  className="fs-14 cursor"
                  onClick={() => {
                    setActiveTab("login");
                  }}
                >
                  Cancel
                </span>
              </div>
              <button
                className="filledBtn w-100"
                onClick={() => {
                  UpdatePassword();
                }}
                disabled={!(error === "valid" && confirmPassword && password)}
              >
                Submit
              </button>
            </div>
          ) : null}
        </div>
        <div className="col-6 h-100 d-none d-md-flex flex-column justify-content-center align-items-center position-relative">
          <img
            src={require("../../assets/bg2.png")}
            alt="logo"
            className="w-100 h-100"
          />
          <img
            src={require("../../assets/machine.png")}
            alt="logo"
            className="w-100 h-100"
            style={{ position: "absolute", objectFit: "contain" }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
